/* eslint-disable sort-keys */

const citifyd = {
  palette: {
    black: '#1b2330',
    white: '#ffffff',
    grayDark: '#373840',
    gray: '#9b9b9b',
    grayMedium: '#747474',
    grayLight: '#CCCCCC',
    grayLighter: '#EDEDED',
    background: '#f8f8f8',
    primary: '#f5b928',
    quaternary: '#f47920',
    error: '#cc0000',
    highlight: '#f5b928',
    facebookBlue: '#3f69a7',
    intercom: {
      action: '#F5B928',
      background: '#000000',
    },
  },
  font: {
    size: {
      mobile: {
        h1: '40px',
        h2: '24px',
        h3: '22px',
        h4: '20px',
        regular: '18px',
        medium: '16px',
        small: '14px',
        tiny: '12px',
      },
      desktop: {
        h1: '60px',
        h2: '44px',
        h3: '30px',
        h4: '20px',
        large: '18px',
        regular: '16px',
        medium: '16px', // Duplicated to match mobile sizes
        small: '14px',
        tiny: '12px',
      },
    },
  },
  flexboxgrid: {
    mediaQuery: 'only screen',
    outerMargin: 1,
    container: {
      sm: 46,
      md: 61,
      lg: 61,
    },
    breakpoints: {
      xs: 0,
      sm: 48,
      md: 64,
      lg: 64,
    },
  },
}

export default citifyd
